var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-page"},[_c('img',{staticClass:"landing-image",attrs:{"src":require("@/assets/landing-poster.jpg"),"alt":"蒲缇烘焙"},on:{"click":_vm.goToLogin}})])
}
var staticRenderFns = []

export { render, staticRenderFns }